import classNames from "classnames";
import { ChangeEvent, forwardRef, useCallback } from "react";

import Label from "components/Label";
import styles from "./styles.module.scss";

export interface Props {
  autoFocus?: boolean;
  className?: string;
  inputClassName?: string;
  label?: string;
  maxLength?: number;
  onChange?: (value: string) => void;
  placeholder?: string;
  value?: string;
}

const TextAreaInput = forwardRef<HTMLTextAreaElement, Props>(
  function ForwardedTextInput(
    { className, inputClassName, label, onChange = () => null, ...props },
    ref
  ) {
    const handleChange = useCallback(
      (event: ChangeEvent<HTMLTextAreaElement>) => {
        onChange(event.target.value);
      },
      [onChange]
    );

    return (
      <div className={classNames(styles.container, className)}>
        {label && <Label type="light">{label}</Label>}

        <textarea
          className={classNames(styles.input, inputClassName)}
          onChange={handleChange}
          ref={ref}
          {...props}
        />
      </div>
    );
  }
);

export default TextAreaInput;
